
import Splide from "@splidejs/splide";
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';

export default class{
    constructor(){
        this.run(document);
    }
    run(d){
        const contactSlider = d.querySelector("[data-contact-slider]");
        if(contactSlider) {
            const splide = new Splide('[data-contact-slider]', {
                type: 'loop',
                autoWidth: true,
                pagination: false,
                drag: false,
                arrows: false,
                gap: 0,
                autoScroll: {
                    speed: .5, 
                    pauseOnHover: false, 
                    autoStart: true,
                },
            }).mount({AutoScroll});
        }

        const blog_sliders = d.querySelectorAll('[data-blog-slider]');
        blog_sliders.forEach(el => {
            const main = new Splide( el.querySelector('[data-main-slider]'), {
                gap: 20,
                perPage: 1,
                pagination : false,
                arrows : false,
                drag : true,
                autoWidth: true,
                focus : 'center',
                breakpoints : {
                    640: {
                        gap : 10,
                    },
                },
            });
            
            const thumbnails = new Splide( el.querySelector('[data-thumbnail-slider]'), {
                rewind : true,
                arrows : false,
                fixedWidth : 196,
                fixedHeight : 130,
                isNavigation : true,
                pagination : false,
                cover : true,
                dragMinThreshold: {
                    mouse : 4,
                    touch : 10,
                },
                breakpoints : {
                    1024: {
                        fixedWidth : 130,
                        fixedHeight : 87,
                    },
                    575: {
                        fixedWidth : 100,
                        fixedHeight : 67,
                    },
                },
            });
            
            main.sync( thumbnails );
            main.mount();
            thumbnails.mount();
        });

        const shop_sliders = d.querySelectorAll('[data-shop-slider]');
        shop_sliders.forEach(el => {
            const main = new Splide( el.querySelector('[data-main-slider]'), {
                gap: 20,
                perPage: 1,
                pagination : false,
                arrows : false,
                drag : true,
                autoWidth: true,
                focus : 'center',
                breakpoints : {
                    640: {
                        gap : 10,
                    },
                },
            });
            
            const thumbnails = new Splide( el.querySelector('[data-thumbnail-slider]'), {
                rewind : true,
                arrows : false,
                fixedWidth : 145,
                fixedHeight : 97,
                isNavigation : true,
                pagination : false,
                cover : true,
                dragMinThreshold: {
                    mouse : 4,
                    touch : 10,
                },
                breakpoints : {
                    1024: {
                        fixedWidth : 130,
                        fixedHeight : 87,
                    },
                    575: {
                        fixedWidth : 100,
                        fixedHeight : 67,
                    },
                },
            });
            
            main.sync( thumbnails );
            main.mount();
            thumbnails.mount();
        });
    }
}